import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { englishData } from '../../data/departmentalData/english';

const English = () => {
  return <TemplatePage data={englishData} />;
};

export default English;
